import clsx from 'clsx';

export const ToolbarDivider = ({ className }: { className?: string }) => {
  return (
    <div
      className={clsx(
        'w-[1px] bg-non-hover-border h-5 hidden sm:block',
        className,
      )}
    />
  );
};
